"use client";
import React, { useState } from "react";
import { useTranslations } from "next-intl";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import CookieDialog from "../../components/common/CookieDialog";
import UseHotjar from "../../components/common/HotJar/HotJar";
import { COMPANY_INFO_EMAIL } from "@/constants/sleapContact";

export default function PrivacyPolicy() {
  const [openCookieModal, setOpenCookieModal] = useState(false);
  const t = useTranslations("PrivacyPolicy");

  return (
    <div className="flex flex-col justify-between bg-lightwhite dark:bg-sleap-gray-950">
      <Header />

      <div className="container mx-auto dark:text-lightwhite text-sleap-gray-950 flex flex-col items-center gap-4">
        <div className="container py-12">
          <h3 className="pb-6 text-transparent bg-clip-text bg-gradient-to-r to-5% from-primary via-secondary via-15% to-secondary">
            {t("pageTitle")}
          </h3>

          <div className="flex flex-col gap-6">
            <p>{t("effectiveDate")}</p>
            <p>{t("intro")}</p>

            <p>{t("infoCollectTitle")}</p>
            <p>{t("infoCollectA")}</p>
            <p>{t("infoCollectB")}</p>
            <p>{t("infoCollectC")}</p>
            <p>
              {t("infoCollectD")}{" "}
              <a
                href="https://policies.google.com/privacy"
                className="text-primary hover:underline"
                target="_blank"
              >
                {t("googlePrivacy")}
              </a>
              .
            </p>

            <p>{t("howWeUseTitle")}</p>
            <p>{t("howWeUseA")}</p>
            <p>{t("howWeUseB")}</p>
            <p>{t("howWeUseC")}</p>
            <p>{t("howWeUseD")}</p>
            <p>{t("howWeUseE")}</p>

            <p>{t("infoShareTitle")}</p>
            <p>{t("infoShareA")}</p>
            <p dangerouslySetInnerHTML={{ __html: t("infoShareB") }} />
            <p>{t("infoShareC")}</p>

            <p>{t("securityTitle")}</p>
            <p>
              {t("securityText")}
              <br />
              This site is protected by reCAPTCHA and the Google{" "}
              <a
                href="https://policies.google.com/privacy"
                className="text-primary hover:underline"
                target="_blank"
              >
                {t("googlePolicy")}
              </a>{" "}
              and{" "}
              <a
                href="https://policies.google.com/terms"
                className="text-primary hover:underline"
                target="_blank"
              >
                {t("googleTerms")}
              </a>{" "}
              apply.
            </p>

            <p>{t("rightsTitle")}</p>
            <p>{t("rightsText")}</p>

            <p>{t("childrenTitle")}</p>
            <p>{t("childrenText")}</p>

            <p>{t("internationalTitle")}</p>
            <p>{t("internationalText")}</p>

            <p>{t("changesTitle")}</p>
            <p>{t("changesText")}</p>

            <p>{t("contactTitle")}</p>
            <p>
              {t("contactText")}{" "}
              <a
                href={`mailto:${COMPANY_INFO_EMAIL}`}
                className="text-primary hover:underline"
              >
                {COMPANY_INFO_EMAIL}
              </a>
              .
            </p>

            <p>{t("acceptance")}</p>

            <div className="flex w-full">
              <button
                className="secondary dark:bg-lightwhite dark:text-sleap-gray-950 bg-sleap-gray-950 text-lightwhite font-inter py-4 px-6 shadow"
                onClick={() => setOpenCookieModal(true)}
              >
                {t("cookieButton")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <CookieDialog
        page="privacy"
        openCookieModal={openCookieModal}
        callBackFn={() => setOpenCookieModal(false)}
      />

      <Footer />
      <UseHotjar />
    </div>
  );
}
